import keycloak from "../keycloak";

export const isLivingMapUser = (): boolean => {
  const regex = /living_map/g;
  return keycloak.tokenParsed?.full_groups.some((value: string) =>
    regex.test(value)
  );
};
